module.exports = __webpack_public_path__ + "static/media/loading.50807eb4.gif";